import { render } from "./TripBuyerDetails.vue?vue&type=template&id=3dc717ae&lang=pug"
import script from "./TripBuyerDetails.vue?vue&type=script&lang=ts"
export * from "./TripBuyerDetails.vue?vue&type=script&lang=ts"
script.render = render

export default script